export const GET_ALL_NOTES = "note/GET_ALL";
export const POPULATE_ALL_NOTES = "note/POPULATE_ALL";
export const GET_NOTE_INFO = "note/GET_INFO";
export const POPULATE_NOTE_INFO = "note/POPULATE_INFO";
export const SUBMIT_NEW_NOTE = "note/SUBMIT_NEW";
export const UPDATE_NOTE = "note/UPDATE";
export const DELETE_NOTE = "note/DELETE";
